<template>
  <div
      class="spacer"
      :class="`spacer-${spacerClass}`"
  ></div>
</template>

<script lang="ts" setup>
import {
  computed,
} from 'vue';

const props = defineProps({
  size: {
    type: String,
    default: 'm',
  },
});

const spacerClass = computed(() => {
  switch (props.size) {
    case 's':
      return 'small';
    case 'm':
      return 'medium';
    case 'l':
      return 'large';
    case 'xl':
      return 'extra-large';
    default:
      return props.size;
  }
});
</script>

<style lang="scss">
@import 'src/scss/component-helpers';

.spacer {
  height: 1em;

  &.spacer {
    &-small {
      @include font-small;
    }

    &-medium {
      @include font-large;
    }

    &-large {
      @include font-h1;
    }

    &-extra-large {
      @include font-regular(100px);
    }
  }
}
</style>
